module.exports = __webpack_public_path__ + "img/up_arrow.61e002c3.svg";